import React from "react";
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import Logout from "./components/Logout/Logout";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Jobs from "./pages/Jobs";
import Google from "./pages/Google";
import S3 from "./pages/S3";
import Executions from "./pages/Executions";
import {SessionContext} from "./util/SessionContext";
import useAppContext from "./util/AppContext";
import NewJob from "./pages/NewJob";


export default function AppRoutes() {
    const location = useLocation();
    const appContext = useAppContext();

    const sessionContext:SessionContext = useAppContext()?.sessionContext!;
    const loggedIn = sessionContext.valid() && location.pathname !== "/logout";

    let content = (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/home" element={<Home />} />
            <Route path="/dashboard" element={appContext?.sessionContext.valid() ? <Dashboard/> : <Home/>} />
            <Route path="/executions" element={appContext?.sessionContext.valid() ? <Executions/> : <Home/>} />
            <Route path="/jobs" element={appContext?.sessionContext.valid() ? <Jobs/> : <Home/>} />
            <Route path="/google" element={appContext?.sessionContext.valid() ? <Google/> : <Home/>} />
            <Route path="/s3" element={appContext?.sessionContext.valid() ? <S3/> : <Home/>} />
            <Route path="/new-job" element={appContext?.sessionContext.valid() ? <NewJob/> : <Home/>} />

            <Route path="/*" element={<Navigate to="/" replace state={{
                referrer: {
                    pathname: location.pathname,
                    search: location.search,
                },
            }} />} />
        </Routes>
    )

    if (!loggedIn) {
        content = (
            <Routes>
                <Route path="/logout" element={<Logout />} />
                <Route path="/*" element={<Home />} />
            </Routes>
        )
    }
    return (
        content
    );
}